import { handleActions } from 'redux-actions'

const initialValue = {
  access_token: null,
  loading: false,
  show_viewer: false,
}

export default handleActions({
  SHOW_ACCESS_TOKEN_MODAL(state) {
    return { ...state, loading: true, show_viewer: true }
  },

  HIDE_ACCESS_TOKEN_MODAL(state) {
    return { ...state, show_viewer: false, access_token: null }
  },

  GET_ACCESS_TOKEN_FULFILLED(state, { payload }) {
    return { ...state, loading: false, access_token: payload }
  },
}, initialValue)
